import { createContext, PropsWithChildren } from "react";
import { Promotion } from "~/entities/promotionEntities";

interface PromotionContextValue {
  scheduledPromotions: Promotion[];
}

const PromotionContext = createContext<PromotionContextValue>({
  scheduledPromotions: [],
});

export const PromotionContextProvider = ({
  scheduledPromotions,
  children,
}: PropsWithChildren<PromotionContextValue>) => (
  <PromotionContext.Provider value={{ scheduledPromotions }}>
    {children}
  </PromotionContext.Provider>
);

export default PromotionContext;
